// Framework and third-party non-ui
import React, { useContext } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

// App components
import { signIn, 
  loadPortal, 
  createDetourFolderIfNotPresent, 
  createFeatureService, 
  existsDetourFeatureService,
  getFeatureServiceItem,
  updateItem, 
  getLayerTemplate, getTableTemplate, addTemplatesToDef } from 'data/oauth';
import { UserContext } from 'contexts/UserContext';

// JSON & Styles
import { StyledLoginButton } from './Login-styled';

const tripHistoryId = 0;
const favoritesId = 1;

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Login = ({ ...rest }) => {
  const classes = useStyles();
  const { setUserInfo, oauthInfo } = useContext(UserContext);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const handleErrorLoggingIn = (msg) => {
    alert('Error logging in')
    console.log(msg)
    handleToggle();
  };

  const attemptLogin = async () => {
      let portal;
      let detourFeatureService;
      let detourFolder;
      let itemId;
      let serviceUrl;
      let favoritesUrl;
      let tripHistoryUrl;
      let tableTemplate;
      let layerTemplate;

      const userInfo = await signIn(oauthInfo);
      setUserInfo(userInfo);



      //Get user portal
      try {
        portal = await loadPortal(userInfo.credential.token);
      } 
      catch(e) {
        handleErrorLoggingIn('Error signing into Portal');
        return;
      };
    
      handleToggle()

      //Get detour folder, create if not yet exists
      try {
        detourFolder = await createDetourFolderIfNotPresent(portal); //Creates and retrieves detour folder
      }
      catch(e) {
        handleErrorLoggingIn('Error creating detour folder');
        return;
      }

      //detourFolderId is null if the DETOUR folder is not found
      if(detourFolder){
        
        try {
          let params = {
            folder: detourFolder
          };
          let items = await portal.user.fetchItems(params);
          if(!items.items.length || !existsDetourFeatureService(items.items, portal.user.username)){
            console.log('Feature service does not exist')
            //Create feature service
            detourFeatureService = await createFeatureService(portal, detourFolder.id, userInfo.credential.token);
            itemId = detourFeatureService.data.itemId;
            serviceUrl = detourFeatureService.data.serviceurl;
          }else{
            detourFeatureService = getFeatureServiceItem(items.items, portal.user.username);
            itemId = detourFeatureService.id;
            serviceUrl = detourFeatureService.url;
          }
        }
        catch(e){
          handleErrorLoggingIn('Error creating feature service in detour folder');
          return;
        }
        try{
          await updateItem(portal, userInfo.credential.token, itemId);
        }catch(e){
          console.log('Error updating item');
        }

        layerTemplate = await getLayerTemplate(userInfo.credential.token); //Trip history layer template
        tableTemplate = await getTableTemplate(userInfo.credential.token); //Favorites table template

        try{
          await addTemplatesToDef(serviceUrl, layerTemplate.data, tableTemplate.data, userInfo.credential.token);
          favoritesUrl = serviceUrl + '/' + favoritesId;
          tripHistoryUrl = serviceUrl + '/' + tripHistoryId;
          setUserInfo({...userInfo, favoritesUrl, tripHistoryUrl})
        }catch(e){
          handleErrorLoggingIn('Error adding to definition');
          return;
        }

      }
      handleToggle();
  };

  return (
    <>
      <StyledLoginButton color="primary"
      data-testid="Login" onClick={attemptLogin} {...rest}>
        Login
      </StyledLoginButton>
      <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Login;
